import { render, staticRenderFns } from "./newsCoreDetail.vue?vue&type=template&id=26512632&scoped=true&"
import script from "./newsCoreDetail.vue?vue&type=script&lang=js&"
export * from "./newsCoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./newsCoreDetail.vue?vue&type=style&index=0&id=26512632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26512632",
  null
  
)

export default component.exports